// Mock data for Edu9 Career Guidance Landing Page

export const navigationData = {
  logo: "Edu9",
  menuItems: [
    { label: "Services", href: "#services" },
    { label: "Contact Us", href: "#contact" }
  ]
};

export const heroData = {
  headline: "Become a Commercial Pilot with Confidence",
  subtext: "100s of successful pilots produced | Your journey to the skies starts here",
  ctaText: "Book Career Counseling",
  backgroundImage: "https://images.unsplash.com/photo-1764547168268-1c8b531bce9f"
  
};


export const servicesData = {
  sectionTitle: "We Handle the Hard Part",
  sectionSubtitle: "Focus on your dream while we take care of the complexities",
  services: [
    {
      id: 1,
      icon: "FileCheck",
      title: "eGCA Registration",
      description: "Seamless assistance with eGCA portal registration and documentation for aspiring pilots."
    },
    {
      id: 2,
      icon: "Stethoscope",
      title: "C2 / C1 Medicals",
      description: "Complete guidance for Class 1 & Class 2 medical examinations with DGCA-approved medical examiners."
    },
    {
      id: 3,
      icon: "ClipboardCheck",
      title: "Board Verification",
      description: "End-to-end support for educational board verification required by DGCA."
    },
    {
      id: 4,
      icon: "Hash",
      title: "DGCA Computer Number",
      description: "Expert help in obtaining your unique DGCA computer number for pilot licensing."
    }
  ]
};

export const educationData = {
  sectionTitle: "Aviation Education Excellence",
  sectionSubtitle: "Comprehensive training programs designed for success",
  programs: [
    {
      id: 1,
      title: "DGCA Ground Classes",
      description: "Master the theoretical foundation with our expert-led ground school covering Air Regulations, Navigation, Meteorology, and Technical General.",
      features: ["Expert Instructors", "Updated Curriculum", "Practice Tests", "Doubt Sessions"],
      image: "https://images.pexels.com/photos/4207314/pexels-photo-4207314.jpeg"
    },
    {
      id: 2,
      title: "Cadet Program Preparation",
      description: "Get fully prepared for prestigious airline cadet programs with comprehensive aptitude training, interview coaching, and simulator assessments.",
      features: ["Aptitude Training", "Interview Prep", "Simulator Sessions", "Airline Partnerships"],
      image: "https://images.unsplash.com/photo-1762854630367-7b302716e85f"
    }
  ]
};

export const pricingHighlightData = {
  badge: "Edu9 Beauty",
  title: "Pay-As-You-Go Model",
  subtitle: "Transparent. Flexible. Student-Friendly.",
  description: "No burden of one-stretch payments. Our stage-wise fee structure ensures you pay only for what you need, when you need it. Complete transparency in every step of your aviation journey.",
  benefits: [
    "Stage-wise payment structure",
    
    "Complete cost breakdown upfront"
  ]
};

export const ftoPartnershipsData = {
  sectionTitle: "Global FTO Partnerships",
  sectionSubtitle: "Train at world-class Flight Training Organizations",
  regions: [
    {
      id: 1,
      region: "India",
      flag: "🇮🇳",
      ftos: ["Indira Gandhi Rashtriya Uran Akademi", "CAE Gondia", "Rajiv Gandhi Academy", "GATI Bangalore"]
    },
    {
      id: 2,
      region: "USA",
      flag: "🇺🇸",
      ftos: ["ATP Flight School", "L3Harris Flight Academy", "Phoenix East Aviation"]
    },
    {
      id: 3,
      region: "Europe",
      flag: "🇪🇺",
      ftos: ["FTE Jerez (Spain)", "Lufthansa Aviation Training", "CAE Oxford Aviation Academy"]
    },
    {
      id: 4,
      region: "Asia Pacific",
      flag: "🌏",
      ftos: ["Singapore Flying College", "CTC Aviation (NZ)", "Airways Aviation (Australia)"]
    }
  ]
};

export const contactData = {
  phone: "9133311450",
  email: "ceo@edu9.in",
  address: "Flat No 1312, 12th Floor, Vasavi Mpm Grand, beside Ameerpet Metro Station, Ameerpet, Hyderabad, Telangana 500073",
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.5292568421182!2d78.44231507369048!3d17.43436460145306!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9160af7ddf1b%3A0xd324b68f71027183!2sEdu9%20Career%20Guidance%20%7C%20B.Tech%2C%20Diploma%2C%20MBA%2C%20B.Sc.Agriculture%2C%20B.V.SC%20%26%20A.H%2C%20MBBS%20Colleges%20Best%20Career%20Guidance!5e0!3m2!1sen!2sin!4v1769601355682!5m2!1sen!2sin",
  finalCta: "Start Your Pilot Journey Today"
};

export const statsData = [
  { value: "500+", label: "Successful Pilots" },
  { value: "50+", label: "FTO Partners" },
  { value: "10+", label: "Years Experience" },
  { value: "98%", label: "Success Rate" }
];
